document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartDrawer', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'switch:cart:afteradditem',
            () => {

              Object.keys(Alpine.store('modals').modals).forEach((modal) => {
                Alpine.store('modals').close(modal);
              });

              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});



/*
document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartDrawer', ({ openOnAddToCart }) => {
    return {
      init() {
        Alpine.store('modals').register('cart', 'rightDrawer');

        this.refreshCartData();
        this.setupQtyInputs();
        this.setupRemoveButtons();
        this.setupPlusMinusButtons();

        if (openOnAddToCart === true) {
          document.body.addEventListener('switch:cart:afteradditem', () => {
            Object.keys(Alpine.store('modals').modals).forEach((modal) => {
              Alpine.store('modals').close(modal);
            });
            Alpine.store('modals').open('cart');

            this.refreshCartData();
            this.setupQtyInputs();
            this.setupRemoveButtons();
            this.setupPlusMinusButtons();
          });
        }

        document.body.addEventListener('switch:cart:update', () => {
          this.refreshCartData();
          this.setupQtyInputs();
          this.setupRemoveButtons();
          this.setupPlusMinusButtons();
        });

        document.body.addEventListener('switch:cart:removeitem', () => {
          this.refreshCartData();
          this.setupQtyInputs();
          this.setupRemoveButtons();
          this.setupPlusMinusButtons();
        });
      },

      updateShippingBar(cart) {
        const threshold = 3900;
        const cartTotal = cart.total_price;

        const shippingBarMessage = document.getElementById('CartShippingBarMessage');
        if (!shippingBarMessage) return;

        if (cartTotal >= threshold) {
          shippingBarMessage.innerText = '🎉 You qualify for free shipping!';
        } else {
          const remainingCents = threshold - cartTotal;
          const remainingDollars = (remainingCents / 100).toFixed(2);
          shippingBarMessage.innerText = `Add $${remainingDollars} more to get free shipping!`;
        }
      },

      updateLiveRegion(cart) {
        const liveRegion = document.getElementById('cart-live-region-text');
        if (liveRegion) {
          const totalPrice = (cart.total_price / 100).toFixed(2);
          liveRegion.innerText = `New subtotal: $${totalPrice}`;
        }
      },

      refreshCartData() {
        fetch('/cart.json')
          .then((res) => {
            if (!res.ok) throw new Error('Network response was not ok');
            return res.json();
          })
          .then((cart) => {
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);
          })
          .catch((error) => {
            console.error('Error fetching cart:', error);
          });
      },

      setupQtyInputs() {
        document.querySelectorAll('.qty-input[data-line]').forEach(input => {
          input.removeEventListener('change', this.qtyInputHandler);
          input.addEventListener('change', this.qtyInputHandler.bind(this));
        });
      },

      qtyInputHandler(event) {
        let quantity = parseInt(event.target.value);
        if (isNaN(quantity) || quantity < 1) {
          quantity = 1;
          event.target.value = quantity;
        }
        const line = event.target.dataset.line;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: quantity }),
        })
          .then(res => res.json())
          .then(cart => {
            document.body.dispatchEvent(new Event('switch:cart:update'));
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);
          })
          .catch(console.error);
      },

      setupRemoveButtons() {
        document.querySelectorAll('.remove-item-btn[data-line]').forEach(button => {
          button.removeEventListener('click', this.removeBtnHandler);
          button.addEventListener('click', this.removeBtnHandler.bind(this));
        });
      },

      removeBtnHandler(event) {
        event.preventDefault();
        const line = event.currentTarget.dataset.line;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity: 0 }),
        })
          .then(res => res.json())
          .then(cart => {
            document.body.dispatchEvent(new Event('switch:cart:removeitem'));
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);
          })
          .catch(console.error);
      },

      setupPlusMinusButtons() {
        document.querySelectorAll('button[aria-label="-"]').forEach(button => {
          button.removeEventListener('click', this.decrementHandler);
          button.addEventListener('click', this.decrementHandler.bind(this));
        });

        document.querySelectorAll('button[aria-label="+"]').forEach(button => {
          button.removeEventListener('click', this.incrementHandler);
          button.addEventListener('click', this.incrementHandler.bind(this));
        });
      },

      decrementHandler(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const container = button.closest('div');
        if (!container) return;

        const input = container.querySelector('input.qty-input[data-line]');
        if (!input) return;

        let quantity = parseInt(input.value) || 1;
        quantity = Math.max(quantity - 1, 1);
        input.value = quantity;

        const line = input.dataset.line;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity }),
        })
          .then(res => res.json())
          .then(cart => {
            document.body.dispatchEvent(new Event('switch:cart:update'));
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);
          })
          .catch(console.error);
      },

      incrementHandler(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const container = button.closest('div');
        if (!container) return;

        const input = container.querySelector('input.qty-input[data-line]');
        if (!input) return;

        let quantity = parseInt(input.value) || 1;
        quantity = quantity + 1;
        input.value = quantity;

        const line = input.dataset.line;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(line), quantity }),
        })
          .then(res => res.json())
          .then(cart => {
            document.body.dispatchEvent(new Event('switch:cart:update'));
            this.updateShippingBar(cart);
            this.updateLiveRegion(cart);
          })
          .catch(console.error);
      },
    };
  });
});
*/